import { Fragment } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { LEGAL, UPDATED, type Block } from "./docs";
import { Footer } from "../shell/Footer";

// /legal/:slug — public pages (no sign-in): privacy, terms, refunds, grievance officer, security, cookies.
// [[text]] in the drafts marks a detail Altekore still has to fill in; it shows highlighted.
function Text({ t }: { t: string }) {
  const parts = t.split(/(\[\[[^\]]+\]\])/g);
  return <>{parts.map((x, i) => x.startsWith("[[") ? <span key={i} className="blank" title="To be filled in">{x.slice(2, -2)}</span> : <Fragment key={i}>{x}</Fragment>)}</>;
}
function BlockView({ b }: { b: Block }) {
  if (typeof b === "string") return <p><Text t={b} /></p>;
  if ("list" in b) return <ul>{b.list.map((x, i) => <li key={i}><Text t={x} /></li>)}</ul>;
  const [head, ...rows] = b.table;
  const headed = b.table[0].length > 2;
  return <table>{headed && <thead><tr>{head.map((h) => <th key={h}>{h}</th>)}</tr></thead>}
    <tbody>{(headed ? rows : b.table).map((r, i) => <tr key={i}>{r.map((c, j) => j === 0 && !headed ? <th key={j}>{c}</th> : <td key={j}><Text t={c} /></td>)}</tr>)}</tbody></table>;
}

export function LegalPage() {
  const { slug } = useParams();
  const doc = LEGAL.find((d) => d.slug === slug);
  if (!doc) return <Navigate to="/legal/privacy" replace />;
  const drafts = JSON.stringify(doc).includes("[[");
  return (
    <div className="legal">
      <header className="legal-top">
        <Link to="/" className="brand"><img className="mark" src="/mark.svg" alt="" width={28} height={28} /><span>Altekore Books</span></Link>
        <Link to="/">Back to Books</Link>
      </header>
      <div className="legal-body">
        <nav className="legal-nav" aria-label="Legal pages">
          {LEGAL.map((d) => <Link key={d.slug} to={`/legal/${d.slug}`} className={d.slug === doc.slug ? "active" : undefined} aria-current={d.slug === doc.slug ? "page" : undefined}>{d.title}</Link>)}
        </nav>
        <article className="legal-doc">
          <h1>{doc.title}</h1>
          <p className="meta">{doc.summary} Last updated {UPDATED}.</p>
          {drafts && <p className="draft">Draft for review: the highlighted details are still to be filled in.</p>}
          {doc.sections.map((s) => <section key={s.h}><h2>{s.h}</h2>{s.body.map((b, i) => <BlockView key={i} b={b} />)}</section>)}
        </article>
      </div>
      <Footer kind="public" />
    </div>
  );
}
